<template>
  <div>
    <Table  :columns="columns12" :data="OrderinfoLists" max-height="600">
    </Table>
  </div>
</template>

<script>
export default {
  name: 'OrderDetailList',
  props: {
    OrderinfoLists: Array,
    State: Array
  },
  data () {
    return {
      columns12: [
        {
          title: '明细ID',
          key: 'OrderList_ID'
        },
        {
          title: '物料编码',
          key: 'ProductID'
        },
        {
          title: '物料名称',
          key: 'Product_Name'
        },
        {
          title: '属性汇总',
          key: 'Attribute_Summary'
        },
        {
          title: '大类',
          key: 'Classification'
        },
        {
          title: '数量',
          key: 'Quantity'
        },
        {
          title: '单价',
          key: 'Unit_Price'
        },
        {
          title: '金额',
          key: 'Amount'
        }
      ]
    }
  },
  computed: {
    disabled: function () {
      if (this.State === '查看') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
  }
}
</script>
